import React, { Component } from 'react';
import './style.css';
class Shim extends Component {
    constructor(props) {
        super(props);
        this.state = {
            css:{
                height:50
            }
        };
    }
    componentDidMount() {
        this.fixCss();
        window.addEventListener('resize',() => {
            this.fixCss();
        })
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this._resizeListener);
        clearTimeout(this.timeouter)
        this.setState = (state, callback) => {
            return
        };
    }
    render() {
        return (
            <div className="shim_box">
                
            </div>
        );
    }
    fixCss = () => {
        let clientWidth = document.body.clientWidth;
        let ratio = 1;
        if(clientWidth < 750){
            ratio = clientWidth/750;
        }
        this.setState({
            css:{
                height:50*ratio
            }
        })
    }
}

export default Shim;


// WEBPACK FOOTER //
// ./src/components/Shim/index.js